// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"843457e8","849":"3b06f399","942":"dee80022"}[chunkId] + ".chunk.css";
};